import React, { useRef, useState } from "react";
import { format } from "date-fns";

import {
  Content,
  Card,
  CardContainer,
  ListContainer,
  CardList,
  FloatButton,
} from "./styles";
import { Container } from "../../../styles/GlobalStyles";

import Header from "../../../components/Header";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { api } from "../../../services/api";
import { FaRegSadTear } from "react-icons/fa";
import { LinkMenu } from "../../admin/Home/styles";
import SpinnerLoading from "../../../components/SpinnerLoading";
import Alerts from "../../../components/Alerts";

function Vagas() {
  const history = useHistory();
  const location = useLocation();

  const floatButton = useRef();

  const headerLinks = [
    {
      label: "Abrir Nova Vaga",
      to: "/empresa/nova-vaga",
    },
    { label: "Sair", to: "/" },
  ];

  const [vagas, setVagas] = useState({
    andamento: [],
    encerradas: [],
  });

  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState(undefined);

  const [mostrarContent, setMostrarContent] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setMostrarContent(true);
    }, 1500);

    if (location.state?.mensagem) {
      setMensagem({
        show: true,
        titulo: "Ok!",
        detalhe: location.state.mensagem,
      });

      history.replace();
    }

    const carregarVagas = async () => {
      setLoading(true);

      try {
        const retorno = await api.get("/empresas/vagas");

        setVagas(retorno.data);

        setLoading(false);
      } catch (e) {
        setLoading(false);
        if (e.response) {
          return window.alert(e.response.data.erro);
        }
        window.alert("Erro ao consultar vagas, tente novamente mais tarde!");
      }
    };

    carregarVagas();
  }, []);

  const navigateToDetalheVaga = (vaga) =>
    history.push(`/empresa/detalhe-vaga/${vaga.id}`, { vaga });

  return (
    <Container>
      <Header links={headerLinks} theme="black" />
      <Alerts mensagem={mensagem} setMensagem={setMensagem} tipo="sucesso" />
      <Content>
        <h1>Aqui estão as vagas da sua empresa</h1>
        {mostrarContent ? (
          loading ? (
            <SpinnerLoading />
          ) : vagas.andamento.length === 0 && vagas.encerradas.length === 0 ? (
            <>
              <h3>
                Você ainda não abriu nenhuma vaga por aqui.{" "}
                <LinkMenu style={{ color: "green" }} to="/empresa/nova-vaga">
                  Abrir Vaga!
                </LinkMenu>
              </h3>
            </>
          ) : (
            <>
              <header>
                <hr />
                <h3 style={{ color: "green" }}>Em andamento</h3>
              </header>
              <CardContainer umItem={vagas.andamento.length === 1}>
                {vagas.andamento.map((vaga) => (
                  <Card
                    key={vaga.id}
                    onClick={() => navigateToDetalheVaga(vaga)}
                  >
                    {/* <header>
              <p id="finalizado">Aberta em 31/10/2019</p>
            </header> */}
                    <h2>{vaga.cargo}</h2>
                    <h3>{vaga.tipo_vaga}</h3>
                    <h3>
                      {vaga.qtd_vagas} {vaga.qtd_vagas > 1 ? "vagas" : "vaga"}
                    </h3>

                    <p>
                      {vaga.qtd_alunos_vinculados === 0 ? (
                        "Nenhuma solicitação"
                      ) : (
                        <>
                          <em>{vaga.qtd_alunos_vinculados}</em>
                          {vaga.qtd_alunos_vinculados > 1
                            ? " solicitações"
                            : " solicitação"}
                        </>
                      )}
                    </p>
                    <p>
                      {vaga.qtd_candidatos === "0" ? (
                        "Nenhum candidato"
                      ) : (
                        <>
                          <em>{vaga.qtd_candidatos}</em>
                          {vaga.qtd_candidatos > 1
                            ? " candidatos"
                            : " candidato"}
                        </>
                      )}
                    </p>
                  </Card>
                ))}
              </CardContainer>
              <br />
              {vagas.encerradas.length !== 0 && (
                <>
                  <header>
                    <br></br>
                    <hr />
                    <h3>Encerradas</h3>
                  </header>
                  <ListContainer>
                    {vagas.encerradas.map((vaga, i) => (
                      <CardList
                        key={vaga.id}
                        onClick={() => navigateToDetalheVaga(vaga)}
                      >
                        <header style={{ marginBottom: 0 }}>
                          <p id="finalizado">
                            Finalizada em{" "}
                            {format(
                              new Date(vaga.data_encerramento),
                              "dd/MM/yyyy"
                            )}
                          </p>
                          <h2>{vaga.tipo_vaga + " - " + vaga.cargo}</h2>
                        </header>
                        <div>
                          {vaga.qtd_contratados > 0 ? (
                            `${vaga.qtd_contratados} ${
                              vaga.qtd_contratados > 1
                                ? "alunos contratados"
                                : "aluno contratado"
                            }`
                          ) : (
                            <span style={{ color: "red" }}>
                              Marcar alunos contratados
                            </span>
                          )}
                        </div>
                      </CardList>
                    ))}
                  </ListContainer>
                </>
              )}
            </>
          )
        ) : (
          ""
        )}
      </Content>
      <FloatButton
        ref={floatButton}
        onMouseEnter={(e) =>
          (floatButton.current.children[0].textContent = "Abrir nova vaga")
        }
        onMouseLeave={() => (floatButton.current.children[0].textContent = "+")}
        onClick={() => history.push(`/empresa/nova-vaga`)}
      >
        <p>+</p>
      </FloatButton>
    </Container>
  );
}

export default Vagas;
